import { useEffect } from 'react';
import { atom, useSetRecoilState } from 'recoil';
import type { RecoilState } from 'recoil';
import {
  addExtensionListener,
  extensionListenerReadyEvent,
  removeExtensionListener,
  dispatchExtensionEvent,
} from 'domains/extension/extensionEventCreators';
import { isWorkspaceManagerAvailable } from 'modules/workspace-manager';
import { RESPONSE_EVENTS as EXTENSION_RESPONSE_EVENTS } from 'domains/extension/constants';

export enum ExtWindowName {
  Viewer0 = 'viewer0',
  Viewer1 = 'viewer1',
  Reporter = 'reporter',
  Worklist = 'worklist',
  Patient_Jacket = 'patient-jacket',
  AISandbox = 'ai-sandbox',
}

export type ExtTab = {
  windowId: number;
  id: number;
  url: string;
  createdAt: number;
  path: string;
};

export type WindowState = {
  windows: Partial<Record<ExtWindowName, ExtTab | null>>;
};

export const extensionAppState: RecoilState<WindowState> = atom({
  key: 'extension-app-state',
  default: { windows: {} },
});

type SetExtensionStateType = CustomEvent<WindowState>;

export const useExtensionState = (): void => {
  const setExtensionState = useSetRecoilState(extensionAppState);

  useEffect(() => {
    const setExtStateHandler = (event: SetExtensionStateType) => {
      setExtensionState(event.detail);
    };

    const addInjectionListener = !isWorkspaceManagerAvailable();

    const handleExtensionInjected = () => {
      dispatchExtensionEvent(extensionListenerReadyEvent());
      removeExtensionListener(
        EXTENSION_RESPONSE_EVENTS.EXTENSION_INJECTED,
        handleExtensionInjected
      );
    };

    // @ts-expect-error [EN-10263] - TS2345 - Argument of type '(event: SetExtensionStateType) => void' is not assignable to parameter of type 'EventListenerOrEventListenerObject'.
    addExtensionListener(EXTENSION_RESPONSE_EVENTS.WINDOW_STATE_UPDATED, setExtStateHandler);

    if (addInjectionListener) {
      addExtensionListener(EXTENSION_RESPONSE_EVENTS.EXTENSION_INJECTED, handleExtensionInjected);
    } else {
      dispatchExtensionEvent(extensionListenerReadyEvent());
    }

    return () => {
      // @ts-expect-error [EN-10263] - TS2345 - Argument of type '(event: SetExtensionStateType) => void' is not assignable to parameter of type 'EventListenerOrEventListenerObject'.
      removeExtensionListener(EXTENSION_RESPONSE_EVENTS.WINDOW_STATE_UPDATED, setExtStateHandler);
      if (addInjectionListener) {
        removeExtensionListener(
          EXTENSION_RESPONSE_EVENTS.EXTENSION_INJECTED,
          handleExtensionInjected
        );
      }
    };
  }, [setExtensionState]);
};
